import {
    openProductLayerAction, closeShippingAddressFormLayerAction,
    setErrorMessageAction, unsetErrorMessageAction,
    unsetShippingOptionsAction, setShippingOptionsAction,
    setCartAction,
    unsetSelectedFittingOption,
    withoutFittingOptionAction,
    clearFittingService,
} from '../../_flux/actions/product_mixed_stocks_lightbox_actions';
import Cart from '../../_flux/stores/models/cart';
import {setAddressType} from '../../_flux/actions/shipping_address_actions';
import {
    setFirstNameAction as setBillingFirstName,
    setLastNameAction as setBillingLastName,
    setEmailAction as setBillingEmail,
    setTelephoneAction as setBillingTelephone} from '../../_flux/actions/billing_address_actions';
import ShippingAddressStore from '../../_flux/stores/shipping_address_store';
import ProductMixedStocksLightboxStore from '../../_flux/stores/product_mixed_stocks_lightbox_store';
import {showAction as lockUi, hideAction as unlockUi} from '../../_flux/actions/ui_lock_actions';
import ADDRESS_TYPES from '../../_flux/constants/address_types';
import shippingOptionsComputeRequest from '../../_flux/components/product/product_mixed_stocks_shipping_options_compute_request';
import {validateShippingAddress} from './address_validation';

export default function onShippingAddressClick() {
    return () => {
        const {cart} = ProductMixedStocksLightboxStore.getState();
        const errorMessage = 'product-mixed-stocks-shipping-option-compute-failed';
        if (!(cart instanceof Cart)) {
            setErrorMessageAction(errorMessage);
            return null;
        }

        unsetErrorMessageAction();
        setAddressType(ADDRESS_TYPES.RESIDENTIAL);
        const {address, invalid} = ShippingAddressStore.getState();
        validateShippingAddress(address);
        if (invalid.length > 0) {
            return;
        }

        cart.shippingAddress = address;
        lockUi();
        shippingOptionsComputeRequest(cart)
            .then((result) => {
                clearFittingService();
                unlockUi();
                setCartAction(cart);
                unsetSelectedFittingOption();
                withoutFittingOptionAction();
                unsetShippingOptionsAction();
                setShippingOptionsAction(result);
                closeShippingAddressFormLayerAction();
                openProductLayerAction();
                const {firstName, lastName, email, telephone} = address;
                setBillingFirstName(firstName);
                setBillingLastName(lastName);
                setBillingEmail(email);
                setBillingTelephone(telephone);
            })
            .catch(() => {
                unlockUi();
                closeShippingAddressFormLayerAction();
                openProductLayerAction();
                setErrorMessageAction(errorMessage);
            });
    };
}
